import React from 'react';
import Firebase from 'firebase';
import XLSX from 'xlsx';
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);



export default class addDataSets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            file: {},
            option: "excel",
            display: "none",
            alert: "",
            done: false,
            uploading: false
        }
        this.filePicked = this.filePicked.bind(this);
        this.csvTojs = this.csvTojs.bind(this);
        this.renderButton = this.renderButton.bind(this);
    }

    csvTojs() {
        var contex = this;
        var reader = new FileReader();
        // Read file into memory as UTF-8      
        reader.readAsText(this.state.file);
        // Handle errors load
        reader.onload = function (e) {
            contex.loadHandler(e);
            reader.onerror = contex.errorHandler(e);
        }
    }

    loadHandler(event) {
        var csv = event.target.result;
        this.processData(csv);
    }

    replaceSpaces(str) {
        var resp = String(str);
        return resp.trim();
    }

    processData(csv) {
        var done = false;
        var allTextLines = csv.split(/\r\n|\n/);
        var lines = [];
        for (var i = 0; i < allTextLines.length; i++) {
            var data = allTextLines[i].split(';');
            var tarr = [];
            for (var j = 0; j < data.length; j++) {
                var ttl = this.replaceSpaces(data[j]);
                tarr.push(ttl);
            }
            if (i == 0) {
                this.setState({ titles: tarr });
            } else {
                var arrObj = [];
                var obj = {};
                for (var h = 0; h < tarr.length; h++) {
                    var key = this.state.titles[h];
                    obj[key] = tarr[h];
                }
                lines.push(obj);
            }
        }
        const contex = this;
        var data = Object.assign({}, lines);
        var sheetName = this.state.file.name;
        sheetName = sheetName.substring(0, sheetName.lastIndexOf('.'));
        var newPostKey = Firebase.database().ref().child('datasets').push().key;
        var dataSetRef = Firebase.database().ref('datasets').child(localStorage.client_id);
        if (this.state.titles.length >= 2) {
            dataSetRef.child(newPostKey).set({
                [sheetName]: data
            }).then(resp => {
            }).catch(err => {
                this.refs.container.warning(
                    "Fichero no fue añadido, verifique que contenga al menos dos columnas",
                    "upload files.", {
                        timeOut: 3000,
                        extendedTimeOut: 10000
                    });
            });
            dataSetRef.child("tablas").child(newPostKey).set({
                [sheetName]: this.state.titles
            }).then(resp => {
            });
            done = true;
        }
        if (done) {
            this.refs.container.success(
                "Fichero añadido correctamente",
                "upload files.", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                });
        } else {
            this.refs.container.warning(
                "Fichero no fue añadido, verifique que contenga al menos dos columnas",
                "upload files.", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                });
        }
    }

    errorHandler(evt) {
        if (evt.target.error.name == "NotReadableError") {
            this.refs.container.warning(
                "No fue posible leer el archivo",
                "upload files.", {
                    timeOut: 3000,
                    extendedTimeOut: 10000
                });
        }
    }

    filePicked() {
        const contex = this;
        // Get The File From The Input
        var oFile = this.state.file;
        var sFilesheetName = oFile.sheetName;
        // Create A File Reader HTML5
        var reader = new FileReader();
        // Ready The Event For When A File Gets Selected
        reader.onload = function (e) {
            var data = e.target.result;
            var cfb = XLSX.read(data, { type: 'binary' });

            // Loop Over Each Sheet
            cfb.SheetNames.forEach(function (sheetName) {
                // Obtain The Current Row As CSV
                var newPostKey = Firebase.database().ref().child('datasets').push().key;
                var dataSetRef = Firebase.database().ref('datasets').child(localStorage.client_id);
                var oJS = XLSX.utils.sheet_to_json(cfb.Sheets[sheetName]);
                var data = Object.values(oJS);
                var titles = [];
                Object.keys(data[0]).map((title, index) => {
                    var tt = "000" + index + "_" + title
                    titles.push(tt)
                })
                var arrData = [];
                data.map((filas, index) => {
                    var subData = {}
                    Object.values(filas).map((subFila, indexY) => {
                        subData[titles[indexY]] = subFila;
                    })
                    arrData.push(subData)
                })
                if (cfb.Strings.length >= 2) {
                    var nombre = sheetName.substring(0, sheetName.lastIndexOf('.'));
                    if (!nombre) {
                        nombre = sheetName;
                    }
                    console.log({ [nombre]: arrData }, sheetName)
                    dataSetRef.child(newPostKey).set({
                        [nombre]: arrData
                    }).then(resp => {
                        dataSetRef.child("tablas").child(newPostKey).set({
                            [nombre]: titles,
                            "modified_at": Firebase.database.ServerValue.TIMESTAMP
                        }).then(resp => {
                            contex.setState({uploading : "done"});
                            contex.refs.container.success(
                                "Fichero añadido correctamente",
                                "upload files.", {
                                    timeOut: 3000,
                                    extendedTimeOut: 10000
                                });
                        }).catch(err => {
                            contex.refs.container.warning(
                                "Fichero no fue añadido, verifique que contenga al menos dos columnas",
                                "upload files.", {
                                    timeOut: 3000,
                                    extendedTimeOut: 10000
                                });
                        });
                    }).catch(err => {

                    });
                }
            });
        };
        // Tell JS To Start Reading The File.. You could delay this if desired
        reader.readAsBinaryString(oFile);
    }

    renderButton() {
        if (this.state.file !== {}) {
            switch (this.state.uploading) {
                case true:
                    return (
                        <button type="button" style={{ cursor: "wait" }} onClick={() => { }} className="btn btn-outline-success">Subiendo <i className="fa fa-refresh fa-spin"></i></button>
                    )
                case false:
                    return (
                        <button type="button" style={{ cursor: "pointer" }} onClick={() => { this.filePicked(); this.setState({ uploading: true }) }} className="btn btn-success">Subir Archivo</button>
                    )
                case "done":
                return(
                    ""
                )
            }
        }
    }

    render() {
        var reader = new FileReader();
        const contex = this;
        return (
            <div>
                <form className="form-horizontal">
                    <ToastContainer ref="container"
                        style={{ marginTop: "5%" }}
                        toastMessageFactory={ToastMessageFactory}
                        className="toast-top-right" />
                    <fieldset>
                        <legend>Nuevo Set de Datos</legend>
                        {/* <div className="form-group">
                            <label className="col-lg-2 control-label">Tipo de Archivo</label>
                            <div className="col-lg-10">
                                <div className="radio">
                                    <label>
                                        <input type="radio" name="optionsRadios" id="optionsRadios1" value="excel" onClick={(e) => { this.setState({ option: e.target.value }) }} />
                                        Planilla Excel.
                                </label>
                                </div>
                                <div className="radio">
                                    <label>
                                        <input type="radio" name="optionsRadios" id="optionsRadios2" value="csv" onClick={(e) => { this.setState({ option: e.target.value }) }} />
                                        Archivo CSV
                                </label>
                                </div>
                            </div>
                        </div> */}
                        <div className="form-group" style={{ width: "80%", marginLeft: "10%" }}>
                            <div className="input-group image-preview">
                                <input placeholder="" type="text" className="form-control image-preview-filesheetName"
                                    value={this.state.file ? this.state.file.name : ""} disabled="disabled"
                                />
                                <span className="input-group-btn">
                                    <button
                                        type="button"
                                        className="btn btn-default image-preview-clear"
                                        style={{ display: "none" }}>
                                        <span
                                            className="glyphicon glyphicon-remove">
                                        </span>
                                        Clear
                                </button>
                                    <div className="btn btn-primary image-preview-input" onClick={() => { var l = document.getElementById('inputFile'); l.click(); }} >
                                        <span
                                            className="image-preview-input-title">
                                            Buscar
                                    </span>
                                        <input
                                            style={{ display: "none" }}
                                            id="inputFile"
                                            type="file"
                                            accept=".xlsx,.xls"
                                            sheetName="input-file-preview"
                                            onChange={(e) => {
                                                this.setState({ file: e.target.files[0], display: "" });
                                            }}
                                        />
                                    </div>
                                </span>
                                <div style={{ display: this.state.display }} >
                                    {this.renderButton()}
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </form>
                <div style={{ display: this.state.alert }} className="alert alert-dismissible alert-success">
                    <button type="button" onClick={() => this.setState({ alert: "none" })} className="close" data-dismiss="alert">&times;</button>
                    <strong>Consejo: </strong>Recomendamos que la primera columna de tu archivo Excel o CSV sea un campo único (ID, SKU, Código de local, etc.) y que la segunda columna sea el texto a desplegar (o texto representativo).
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/datasets/addDataSets.js